module.exports = __webpack_public_path__ + "media/images/account-and-routing-2a3d9999de8fb643f0333241c99b28ab.jpg";